import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

const Redirectes = [
  <Route
    path="/courses/IPR-CERTIFICATE-COURSE-ONLINE-62bd7ab20cf25cee271fc802"
    element={<Navigate to="/courses/ipr-certificate-course-online" replace />}
  />,
  <Route
    path="/courses/master-corporate-law-online-course-62cfaad00cf2f900a3b186e6"
    element={
      <Navigate to="/courses/master-corporate-law-online-course" replace />
    }
  />,
  <Route
    path="/courses/DRAFTING-LEGAL-PLEADINGS-FOR-INDIAN-COURTS-62481aa70cf238f4a6c17057"
    element={
      <Navigate
        to="/courses/online-certificate-courses-legal-contract-drafting"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFIED-LABOUR-LAWS-EMPLOYMENT-COMPLIANCE-PRACTITIONER-625909850cf207a599d55489"
    element={
      <Navigate to="/courses/online-employment-labour-law-course" replace />
    }
  />,
  <Route
    path="/courses/CERTIFICATE-COURSE-IN-CYBER-LAW-624c0c3f0cf2ee69841076f0"
    element={
      <Navigate to="/courses/online-certificate-course-cyber-law" replace />
    }
  />,
  <Route
    path="/courses/PROFESSIONAL-PARALEGAL-CERTIFICATION-625ffa620cf209e72db0bb19"
    element={
      <Navigate to="/courses/online-paralegal-certification-course" replace />
    }
  />,
  <Route
    path="/courses/INTERNATIONAL-ENVIRONMENTAL-LAW--POLICY-PROGRAM-625001f80cf27b7ac7ab8a25"
    element={
      <Navigate
        to="/courses/online-certificate-course-international-environmental-law-policy-program"
        replace
      />
    }
  />,
  <Route
    path="/courses/CRACKING-THE-EXAMS-FOR-ADVOCATE-ON-RECORD-SUPREME-COURT-624a916d0cf2a19713f3fc3d"
    element={
      <Navigate
        to="/courses/online-course-crack-exam-advocate-on-record-supreme-court"
        replace
      />
    }
  />,
  <Route
    path="/courses/PREVENTION-OF-SEXUAL-HARASSMENT-AT-WORKPLACE-62665a900cf29681da553f59"
    element={
      <Navigate
        to="/courses/online-certificate-course-prevention-sexual-harassment-at-workplace"
        replace
      />
    }
  />,
  <Route
    path="/courses/PREVENTION-OF-SEXUAL-HARASSMENT-POSH-ACT-2013-6263b3ce0cf21a7a70153e4e"
    element={
      <Navigate
        to="/courses/online-certificate-course-prevention-of-sexual-harassment-posh-act-2013"
        replace
      />
    }
  />,
  <Route
    path="/courses/PATENT-AGENT-EXAMINATION-62594c310cf2b8a80bc945c6"
    element={
      <Navigate
        to="/courses/online-certificate-course-patent-agent-examination"
        replace
      />
    }
  />,
  <Route
    path="/courses/FILING-AN-EFFECTIVE-RTI-APPLICATION-625d53d20cf2607fbf8d5bc5"
    element={
      <Navigate
        to="/courses/online-certificate-course-filing-effective-rti-application"
        replace
      />
    }
  />,
  <Route
    path="/courses/PROFESSIONAL-CERTIFICATION-IN-SPORTS-LAW-62839f740cf2c3361a794754"
    element={
      <Navigate
        to="/courses/professional-online-certification-course-sports-law"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATE-PROGRAM-ON-INSOLVENCY-AND-BANKRUPTCY-CODE-62582be90cf207a599d5051c"
    element={
      <Navigate
        to="/courses/online-certificate-course-insolvency-bankruptcy-code"
        replace
      />
    }
  />,
  <Route
    path="/courses/EXPERT-CERTIFICATION-IN-FILING-AND-OBTAINING-TRADEMARKS-624fcdc60cf2ed323dff9b89"
    element={
      <Navigate
        to="/courses/online-certification-course-filing-obtaining-trademarks"
        replace
      />
    }
  />,
  <Route
    path="/courses/ADVANCE-CERTIFICATION-COURSE-ON-HUMAN-RIGHTS-LAW-626a5aa30cf28dbd510d2369"
    element={
      <Navigate
        to="/courses/online-certification-course-human-rights-law"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATION-IN-TAXATION-LAWS-62515ed20cf28d6559ef9b1a"
    element={
      <Navigate
        to="/courses/best-online-certification-course-taxation-laws"
        replace
      />
    }
  />,
  <Route
    path="/courses/THE-ART-AND-PLAN-OF-CROSS-EXAMINATION-625114490cf2c5ec24c80e3b"
    element={
      <Navigate
        to="/courses/online-certificate-course-art-plan-cross-examination"
        replace
      />
    }
  />,
  <Route
    path="/courses/COURSE-ON-ART-LAW-BY-SAYANTAN-MISRA-626fd1e50cf2c3deacec34ad"
    element={
      <Navigate to="/courses/online-certification-course-art-law" replace />
    }
  />,
  <Route
    path="/courses/CERTIFICATE-IN-PROFESSIONAL-POLITICS-62629bab0cf21a7a7014d5df"
    element={
      <Navigate
        to="/courses/online-certification-course-professional-politics"
        replace
      />
    }
  />,
  <Route
    path="/courses/JUVENILE-JUSTICE-CARE-AND-PROTECTION-OF-CHILDREN-ACT-2015-625abe740cf2089d8f2e3bbe"
    element={
      <Navigate
        to="/courses/online-certification-course-juvenile-justice-act-2015"
        replace
      />
    }
  />,
  <Route
    path="/courses/Legal-Research-and-Methodology-66e040f29ef75f4a0dfb6baa"
    element={<Navigate to="/courses/legal-research-methodology" replace />}
  />,
  <Route
    path="/courses/Javascript-Basic-to-Advance-Course-66b35aec65ba792fd428b326"
    element={
      <Navigate to="/courses/online-certification-javascript-course" replace />
    }
  />,
  <Route
    path="/courses/CODE-ON-CIVIL-PROCEDURE-BY-SAMRIDHI-6287842a0cf263967798603c"
    element={
      <Navigate
        to="/courses/online-certification-code-on-civil-procedure-course"
        replace
      />
    }
  />,
  <Route
    path="/courses/CLAT-PG-LLM-2022-62872c900cf22ec8ae8ca4a5"
    element={
      <Navigate to="/courses/online-certification-course-clat-pg-llm" replace />
    }
  />,
  <Route
    path="/courses/EXPERT-COACHING-ON-CRACKING-COMMON-LAW-ADMISSION-TEST--CLAT-628627780cf2f6858c9dccab"
    element={
      <Navigate to="/courses/online-certification-coaching-clat" replace />
    }
  />,
  <Route
    path="/courses/CERTIFICATION-IN-INDIAN-CONSTITUTION-6283559e0cf2555ca92fc77f"
    element={
      <Navigate
        to="/courses/online-certification-course-indian-constitution"
        replace
      />
    }
  />,
  <Route
    path="/courses/FUNDAMENTAL-STUDY-OF-INDIAN-CONSTITUTION-62821d080cf2f49db66a8a9a"
    element={
      <Navigate
        to="/courses/fundamentals-study-of-indian-constitution"
        replace
      />
    }
  />,
  <Route
    path="/courses/INDIAN-EVIDENCE-ACT---ESSENTIAL-GUIDE-FOR-LAW-STUDENTS-627b942a0cf2e9bd712c250c"
    element={
      <Navigate
        to="/courses/online-certification-course-indian-evidence-act"
        replace
      />
    }
  />,
  <Route
    path="/courses/JURISPRUDENCE-A-STUDY-OF-LAW-627a41750cf25d99ddabd830"
    element={
      <Navigate
        to="/courses/online-certification-jurisprudence-course"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATE-COURSE-IN-LAW-OF-EQUITABLE-MORTGAGE-62751e970cf2699f677c2cfa"
    element={
      <Navigate
        to="/courses/online-certificate-course-law-of-equitable-mortgage"
        replace
      />
    }
  />,
  <Route
    path="/courses/COURSE-IN-EFFECTIVE-MANAGERIAL-DECISION-MAKING-6273b7020cf2a2120618e5ac"
    element={
      <Navigate
        to="/courses/online-certificate-course-managerial-decision-making"
        replace
      />
    }
  />,
  <Route
    path="/courses/COURSE-ON-ORGANIZATIONAL-BEHAVIOR-626d13f40cf227f410ff4507"
    element={
      <Navigate
        to="/courses/online-certificate-course-organizational-behaviour"
        replace
      />
    }
  />,
  <Route
    path="/courses/FOOD-TECHNOLOGY-AN-EMERGING-FIELD-626bb8920cf26d8a68dd89d5"
    element={
      <Navigate
        to="/courses/online-certificate-course-food-technology"
        replace
      />
    }
  />,
  <Route
    path="/courses/PROFESSIONAL-ETHICS-OF-LAW-AND-MORAL-CODES-OF-CONDUCT-626a77b40cf278d7fae49ec1"
    element={
      <Navigate
        to="/courses/online-certificate-course-professional-law-moral-codes-of-conduct"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATE-COURSE-IN-GOODS-SERVICES-TAX-626670c10cf2e8e1cfa84d75"
    element={
      <Navigate
        to="/courses/online-certificate-course-goods-service-tax"
        replace
      />
    }
  />,
  <Route
    path="/courses/INTERNATIONAL-SPACE-LAWS-AND-POLICY-6267bf710cf2fac09c0d2868"
    element={
      <Navigate
        to="/courses/online-certificate-course-international-space-laws-policy"
        replace
      />
    }
  />,
  <Route
    path="/courses/online-certification-course-law-LAW-OF-TORTS-WITH-CASE-LAWS-AND-EASY-UNDERSTANDING-6268e2cc0cf2b698cee443f9"
    element={
      <Navigate
        to="/courses/online-certification-course-law-of-torts"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATE-COURSE-IN-GOODS-SERVICES-TAX-626670c10cf2e8e1cfa84d75"
    element={
      <Navigate
        to="/courses/online-certificate-course-goods-service-tax"
        replace
      />
    }
  />,
  <Route
    path="/courses/DRAFTING-OF-COMMERCIAL-AGREEMENT-626644eb0cf20177fb06bbb3"
    element={
      <Navigate
        to="/courses/online-certification-course-drafting-commercial-agreement"
        replace
      />
    }
  />,
  <Route
    path="/courses/Course-on-Property-Law-Materials-And-Commentary-62627b8a0cf2efdf8c24fccf"
    element={
      <Navigate
        to="/courses/online-certification-course-property-law-materials-commentary"
        replace
      />
    }
  />,
  <Route
    path="/courses/ADVANCE-CERTIFICATION-ON-INDIAN-REGULATORY-PRACTICE-626146800cf20167b3743f87"
    element={
      <Navigate
        to="/courses/online-advance-certification-course-indian-regulatory-practice"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATION-ON-PRINCIPALS-OF-IMMUNE-SYSTEM--IMMUNOLOGY-6261078d0cf2df9346c6a65d"
    element={
      <Navigate
        to="/courses/online-certification-course-principals-of-immune-system-immunology"
        replace
      />
    }
  />,
  <Route
    path="/courses/THE-CODE-OF-CRIMINAL-PROCEDURE-1973-626100990cf2c2c97ff00695"
    element={
      <Navigate
        to="/courses/online-certification-course-code-of-criminal-procedure-1973"
        replace
      />
    }
  />,
  <Route
    path="/courses/PRACTICAL-GUIDE-TO-INCORPORATE-A-PVT-LTD-COMPANY-625fe46b0cf2e642644f7aa8"
    element={
      <Navigate
        to="/courses/online-certification-course-incorporate-a-pvt-ltd-company"
        replace
      />
    }
  />,
  <Route
    path="/courses/SPECIALISED-CERTIFICATION-IN-ENGINEERING-LAWS-625fcf040cf26e4a8b9e5cbd"
    element={
      <Navigate
        to="/courses/online-certification-course-engineering-laws"
        replace
      />
    }
  />,
  <Route
    path="/courses/CORPORATE-SOCIAL-RESPONSIBILITY-A-STRATEGIC-APPROACH-625f9ed10cf26e4a8b9e34d1"
    element={
      <Navigate
        to="/courses/online-certification-course-corporate-social-responsibility"
        replace
      />
    }
  />,
  <Route
    path="/courses/LEGAL-DRAFTING-AN-ART-OF-CREATING-LEGAL-DOCUMENTS-625f985b0cf2693ae06bce8a"
    element={
      <Navigate
        to="/courses/online-certification-course-legal-drafting-creating-legal-documents"
        replace
      />
    }
  />,
  <Route
    path="/courses/MASTER-CERTIFICATION-ON-THE-STATUTE-OF-CONSUMER-PROTECTION-625ec4320cf209e72dafdd42"
    element={
      <Navigate
        to="/courses/online-certification-course-statute-of-consumer-protection"
        replace
      />
    }
  />,
  <Route
    path="/courses/JUDICIARY-EXAM-INDIAN-CONTRACT-ACT-625e6ea20cf2118857134e96"
    element={
      <Navigate
        to="/courses/online-certification-course-judiciary-exam-indian-contract-act"
        replace
      />
    }
  />,
  <Route
    path="/courses/Course-on-Basic-of-Science-625e668f0cf2da1a34c0727d"
    element={
      <Navigate
        to="/courses/online-certification-course-basic-of-science"
        replace
      />
    }
  />,
  <Route
    path="/courses/CORPORATE-SECURITIES-LAWS---GOVERNING-THE-INTERMEDIARIES-625e43460cf2a4c0c1351712"
    element={
      <Navigate
        to="/courses/online-certification-course-corporate-securities-laws"
        replace
      />
    }
  />,
  <Route
    path="/courses/LOCAL-SELF-GOVERNANCE-625d4fd10cf25d702b76df9b"
    element={
      <Navigate
        to="/courses/online-certification-course-local-self-governance"
        replace
      />
    }
  />,
  <Route
    path="/courses/LAWS-RELATING-TO-THE-PROTECTION-OF-ACID-ATTACK-VICTIMS-625d27df0cf2a10e5223b420"
    element={
      <Navigate
        to="/courses/online-certification-course-laws-to-protect-acid-attack-victims"
        replace
      />
    }
  />,
  <Route
    path="/courses/SEBI--INSIDER-TRADING-REGULATIONS--COMPLIANCES-625a98d60cf2a10e5222d4a0"
    element={
      <Navigate
        to="/courses/online-certification-course-sebi-insider-trading-regulations-compliances"
        replace
      />
    }
  />,
  <Route
    path="/courses/JUSTICE-WITHOUT-TRIAL-ALTERNATIVE-DISPUTE-RESOLUTION-6259808b0cf268b8bd17ad61"
    element={
      <Navigate
        to="/courses/online-certification-course-justice-without-trial-alternative-dispute-resolution"
        replace
      />
    }
  />,
  <Route
    path="/courses/DEEP-LEARNING-OF-LAW-AND-FORENSIC-SCIENCE-625943270cf2b8a80bc941db"
    element={
      <Navigate
        to="/courses/online-certificate-course-law-forensic-science"
        replace
      />
    }
  />,
  <Route
    path="/courses/INTERNATIONAL-TRADE-LAW-BY-BINDA-SAHNI-625940630cf22740d2ba38be"
    element={
      <Navigate
        to="/courses/online-certificate-course-international-trade-law"
        replace
      />
    }
  />,
  <Route
    path="/courses/CHILD-RIGHTS-LAW-IN-INDIA-POLICIES-AND-PRACTICE-6257ccf30cf2aa78b8489013"
    element={
      <Navigate
        to="/courses/online-certificate-course-child-rights-law-in-india"
        replace
      />
    }
  />,
  <Route
    path="/courses/COMPETITION-LAW-BY-GOPIKA-SKUMAR-625802340cf268e0d5652b5d"
    element={
      <Navigate
        to="/courses/online-certificate-course-competition-law"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFIED-DISCIPLINARY-PROCEEDING--DOMESTIC-ENQUIRY-OFFICER-625803dc0cf268e0d5652ca8"
    element={
      <Navigate
        to="/courses/online-certificate-course-disciplinary-proceeding-domestic-enquiry-officer"
        replace
      />
    }
  />,
  <Route
    path="/courses/CHILD-RIGHTS-LAW-IN-INDIA-POLICIES-AND-PRACTICE-6257ccf30cf2aa78b8489013"
    element={
      <Navigate
        to="/courses/online-certificate-course-child-rights-law-in-india-policies-practice"
        replace
      />
    }
  />,
  <Route
    path="/courses/LAWS-OF-TRANSFER-OF-PROPERTY-ACT-6257c3ca0cf28d6559f1bdae"
    element={
      <Navigate
        to="/courses/online-certificate-course-laws-transfer-of-property-act"
        replace
      />
    }
  />,
  <Route
    path="/courses/LEGAL-DRAFTING-IN-COURT-BAIL-APPEAL-AND-REVISION-6256c7ca0cf2b48cfa2fcd85"
    element={
      <Navigate
        to="/courses/online-certificate-course-legal-drafting-court-bail-appeal-revision"
        replace
      />
    }
  />,
  <Route
    path="/courses/GST-PRACTITIONER-CERTIFICATION-COURSE-62567a350cf268e0d5649254"
    element={
      <Navigate
        to="/courses/gst-practitioner-online-certification-course"
        replace
      />
    }
  />,
  <Route
    path="/courses/JUDICIAL-SERVICES-EXAMINATION-6255188f0cf2aa78b8477a91"
    element={
      <Navigate
        to="/courses/online-certificate-course-judicial-services-examination"
        replace
      />
    }
  />,
  <Route
    path="/courses/Course-on-Financial-Planning-62550ce40cf268e0d5640e51"
    element={
      <Navigate
        to="/courses/online-certfication-course-financial-planning"
        replace
      />
    }
  />,
  <Route
    path="/courses/POLITICAL-STRUCTURE-OF-INDIA-62541e5e0cf23c0ab8929144"
    element={
      <Navigate
        to="/courses/online-certfication-course-political-structure-of-india"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATION-IN-FINANCE-AND-ACCOUNTING-62516eeb0cf2aa78b8463d08"
    element={
      <Navigate
        to="/courses/online-certification-course-finance-accounting"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATE-COURSE-IN-HUMAN-RIGHTS-AND-DUTIES-62501cda0cf27b7ac7ab96df"
    element={
      <Navigate
        to="/courses/online-certificate-course-human-rights-duties"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATE-COURSE-IN-REAL-ESTATE-LAWS-RERA-624e99b70cf28a496e48faea"
    element={
      <Navigate
        to="/courses/online-certificate-course-real-estate-laws-rera"
        replace
      />
    }
  />,
  <Route
    path="/courses/ADVANCE-CERTIFICATION-IN-IPRs--LAW-AND-PROCEDURE-624d880b0cf20efe1ed3d5ed"
    element={
      <Navigate
        to="/courses/online-advance-certification-course-iprs-law-procedure"
        replace
      />
    }
  />,
  <Route
    path="/courses/CERTIFICATE-IN-COPYRIGHT-LAWS-624d87f10cf2f1f88b4f6756"
    element={
      <Navigate
        to="/courses/online-certificate-course-copyright-laws"
        replace
      />
    }
  />,
  <Route
    path="/courses/AN-INTRODUCTION-TO-LAW-OF-CONTRACTS-BY-RANJANI-624d854d0cf2f1f88b4f6662"
    element={
      <Navigate
        to="/courses/online-certificate-course-law-of-contracts"
        replace
      />
    }
  />,
  <Route
    path="/courses/ALTERNATIVE-DISPUTE-RESOLUTION-SPECIAL-CERTIFICATE-PROGRAM-624d47950cf27b7ac7a921a0"
    element={
      <Navigate
        to="/courses/online-certificate-course-alternative-dispute-resolution"
        replace
      />
    }
  />,
  <Route
    path="/courses/PROVISIONS-OF-SARFAESI-ACT-2002-AND-DRT-ACT-624bed440cf2e171404e930f"
    element={
      <Navigate
        to="/courses/online-certificate-course-provisions-of-sarfaesi-act-2002-drt-act"
        replace
      />
    }
  />,
  <Route
    path="/courses/macroeconomics-national-income"
    element={
      <Navigate
        to="/courses/online-certification-course-macroeconomics-national-income"
        replace
      />
    }
  />,
  <Route
    path="/courses/writs-under-constitution-of-india"
    element={
      <Navigate
        to="/courses/online-course-writs-under-constitution-of-india"
        replace
      />
    }
  />,
  <Route
    path="/courses/Professional-Certification-in-Data-Privacy-Law-GDPR-IT-Act-&-DPDP-667c03f0c126db540aee3f89"
    element={
      <Navigate
        to="/courses/online-certification-course-data-privacy-law-gdpr-it-act-dpdp"
        replace
      />
    }
  />,
  <Route
    path="/courses/online-professional-certification-data-privacy-law-course"
    element={
      <Navigate
        to="/courses/online-certification-course-data-privacy-law-gdpr-it-act-dpdp"
        replace
      />
    }
  />,

  <Route
    path="/blogs/best-law-courses-in-india-after-12th"
    element={
      <Navigate to="/blogs/online-law-courses-india-after-12th " replace />
    }
  />,

  // new
  <Route
    path="/courses/bns-2023"
    element={<Navigate to="/courses/online-bns-2023" replace />}
  />,
  <Route
    path="/courses/trademark-agent"
    element={<Navigate to="/courses/trademark-agent-examination" replace />}
  />,
  <Route
    path="/courses/bnss-2023"
    element={<Navigate to="/courses/online-bnss-2023" replace />}
  />,
  <Route
    path="/courses/business-law--comprehensive-certificate-course"
    element={
      <Navigate
        to="/courses/business-law-comprehensive-certificate-course"
        replace
      />
    }
  />,
  <Route
    path="/courses/certification-course-on-hindu--muslim-personal-laws"
    element={
      <Navigate
        to="/courses/hindu-muslim-personal-laws-certification"
        replace
      />
    }
  />,
  <Route
    path="/courses/it-act-2000-and-bsa-2023"
    element={<Navigate to="/courses/it-act-2000-bsa-2023" replace />}
  />,

  <Route
    path="/courses/certification-in-women-laws-and-pocso-act-2012"
    element={
      <Navigate to="/courses/certification-women-laws-pocso-act-2012" replace />
    }
  />,
  <Route
    path="/courses/certificate-in-oral-and-public-health"
    element={<Navigate to="/courses/certificate-oral-public-health" replace />}
  />,
  <Route
    path="/courses/online-certificate-course-prevention-of-sexual-harassment-posh-act-2013"
    element={
      <Navigate
        to="/courses/online-certificate-course-prevention-sexual-harassment-at-workplace"
        replace
      />
    }
  />,

  <Route
    path="/courses/online-certificate-courses-legal-contract-drafting"
    element={
      <Navigate
        to="/courses/online-certificate-course-legal-contract-drafting"
        replace
      />
    }
  />,
];

export default Redirectes;
